module.exports = __webpack_public_path__ + "img/banner.55e59985.png";